import { Header } from './components/Header'
import { AnnouncementBar } from './components/AnnouncementBar'
import { Hero } from './components/Hero'
import { SocialProof } from './components/SocialProof'
import { BusinessTypes } from './components/BusinessTypes'
import { Carousel } from './components/Carousel'
import { Ecosystem } from './components/Ecosystem'
import { TecoposCard } from './components/TecoposCard'
import { Hardware } from './components/Hardware'
import { Comunidad } from './components/Comunidad'
import { Pricing } from './components/Pricing'
import { Assistant } from './components/Assistant'
import { News } from './components/News'
import { ReleaseNotes } from './components/ReleaseNotes'
import { Footer } from './components/Footer'
import { ContactFab } from './components/ContactFab'
import { useReveal } from './components/useReveal'
import { LandingSkeleton, LandingLoadError } from './components/LandingSkeleton'
import { useLandingContent, useLandingContentStore } from '@/features/admin/content/landingContent'
import { NovedadesEnLaPortada } from '@/features/novedades'

/**
 * Landing pública de marketing. El orden y diseño se conservan; cada sección
 * del CMS puede ocultarse desde la administración (mapa `hidden`).
 *
 * El contenido del CMS solo se renderiza cuando es REAL (backend o caché de la
 * última visita): mientras carga se muestran esqueletos y, si la carga falla
 * sin caché, un estado de error con reintento — nunca los defaults.
 */
export function LandingPage() {
  useReveal()
  const { hidden } = useLandingContent()
  const status = useLandingContentStore((s) => s.status)
  const show = (key: string) => !hidden?.[key]

  if (status !== 'ready') {
    return (
      <>
        <div className="min-h-screen bg-background text-foreground font-sans antialiased">
          <Header />
          <main>
            {status === 'loading' ? (
              <LandingSkeleton />
            ) : (
              <LandingLoadError onRetry={() => void useLandingContentStore.getState().load()} />
            )}
          </main>
          <Footer />
        </div>
        <NovedadesEnLaPortada />
      </>
    )
  }

  // El aviso de novedades vive FUERA del <div> de la landing, en el mismo
  // sitio del fragmento en las DOS ramas (goal portal-correcciones 10).
  //
  // 🚨 No es estilo: dentro del <div> cambiaba de POSICIÓN entre la rama de
  // esqueleto y la de contenido (una tiene AnnouncementBar y ContactFab y la
  // otra no), así que al llegar el CMS React lo desmontaba y lo volvía a
  // montar — y con él su petición de novedades y su estado de «ya lo cerré».
  // Medido en navegador: 4 peticiones a /novedades/al-entrar por visita.
  return (
    <>
      <div className="min-h-screen bg-background text-foreground font-sans antialiased selection:bg-primary selection:text-primary-foreground">
        <AnnouncementBar />
        <Header />
        <main>
          {show('hero') && <Hero />}
          {show('growingBusinesses') && <SocialProof />}
          {show('businessTypes') && <BusinessTypes />}
          {show('carousel') && <Carousel />}
          {show('ecosystem') && <Ecosystem />}
          <TecoposCard />
          {show('hardware') && <Hardware />}
          {/* Comunidad de soporte: estática como TecoposCard (sin CMS);
              se oculta sola si VITE_COMUNIDAD_URL no está configurada. */}
          <Comunidad />
          {show('pricing') && <Pricing />}
          {show('contact') && <Assistant />}
          <News />
          {/* Notas de versión en vivo: inmediatamente después de "Lo último",
              sin entrada en el header (decisión 5). Carga en DIFERIDO: cero
              peticiones hasta acercarse a la sección (decisión 7). */}
          <ReleaseNotes />
        </main>
        <Footer />
        <ContactFab />
      </div>
      <NovedadesEnLaPortada />
    </>
  )
}
